<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import { Icon } from '@oat-sa-private/ui-elements';
</script>

<style>
    .non-default {
        color: var(--color-brand);
        padding: 0 1rem;
    }
</style>

<span class="checkmark non-default">
    <Icon name="check-12" ariaHidden />
</span>
